import { Modal } from "antd";

const ImageViewer = ({ visible, image, handleClose, toggleImageModal }: any) => {
    return (
        <>
            <Modal
                visible={visible}
                width={690}
                closable={true}
                footer={null}
                onCancel={handleClose}
                className="flex items-center justify-center"
            >
                <div className="relative">
                    <img
                        src={image}
                        alt="Full-size"
                        className="max-w-[70vw] max-h-[70vh] rounded-lg"
                    />
                    <button
                        onClick={toggleImageModal}
                        className="absolute top-2 right-2 text-white text-2xl font-bold"
                    >
                        {/* &times; */}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default ImageViewer;